import instance from '../instance';
import customEventListeners from '../listeners/custom-event-listeners';

const hasDocumentAdditives = () => {
  const refAttribute = instance.config.referenceAttribute;
  const liveDocument = instance.driver.getLiveDocument();
  const hasDynamicContent = Boolean(liveDocument.querySelector(`:not([${refAttribute}])`));
  const hasCustomListeners = customEventListeners.getAll().length > 0;

  return hasDynamicContent || hasCustomListeners;
};

export default hasDocumentAdditives;
